import InventoryDetails from "./InventoryDetails"

export default ({
  inventory
}) => { 
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: '10px' }}>
      {inventory.map(i => {
        return <InventoryDetails key={i.id} inventoryItem={i} />
      })}
    </div>
  )
}